import env from '@resn/gozer-core/env';
import { isMobile } from '@resn/gozer-env';

export default env((entry) => ({
    entry,
    CDN: __CDN__,
    isMobile,
}));
